import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, BarChart, Bar } from 'recharts';
import Grid from '@material-ui/core/Grid';
import ChartMenu from './../ChartMenu/ChartMenu';
import CustomizedDot from './CustomizedDot';
import { colors, colors1, colors2, colors3, colors4, colors5 } from '../../../../constants//icons/characteristics/Characteristics';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../Actions/Dashboard';

class LineComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: props.title === 'Años' ? 'bar' : 'line',
      colors: colors5
    }
  }

  getData = () => {
    const { data } = this.props;
    let resp = [];
    for (let i = 0; i < data.dataSet.length; i++) {
      if (data[i] !== 0) {
        let temp = {
          name: i.toString(),
          val: data[i]
        }
        resp.push(temp);
      }
    }
    return resp;
  }

  getLine = () => {
    try {
      return this.props.data.map((val, index) => {
        return <Line type="monotone" dataKey={val.name}
          stroke={this.state.colors[index % this.state.colors.length]}
          dot={<CustomizedDot fill={this.state.colors[index % this.state.colors.length]} />}
          isAnimationActive={false}
          key={'line-line-' + index}
          label={{ position: 'top', fontSize: 14 }}
        />
      })
    } catch (e) { }
  }

  getTotal = () => {
    const { data } = this.props;
    let resp = 0;
    for (let i = 0; i < data.length; i++) {
      resp += data[i];
    }
    return <p style={{ fontWeight: 'bold' }}>{'Total: ' + resp} </p>;
  }
  
  getWidth = () => {
    if (this.props.name.includes('fiveyears'))
      return 300;
    return 400;
  }
  
  getMonthId = (month) => {
    switch (month) {
      case 'Ene': return 1;
      case 'Feb': return 2;
      case 'Mar': return 3;
      case 'Abr': return 4;
      case 'May': return 5;
      case 'Jun': return 6;
      case 'Jul': return 7;
      case 'Ago': return 8;
      case 'Sep': return 9;
      case 'Oct': return 10;
      case 'Nov': return 11;
      case 'Dic': return 12;
      default: return 1;
    }

  }
  onClick = (uno) => {
    try {
      if (isNaN(uno.activeLabel)) {
        this.props.actions.selectFilter({ id: this.getMonthId(uno.activeLabel), value: uno.activeLabel }, 'month')
        this.props.onClickGraphic('month', [{ id: this.getMonthId(uno.activeLabel), value: uno.activeLabel }])
      } else {
        this.props.actions.selectFilter({ id: Number(uno.activeLabel), value: uno.activeLabel }, 'year')
        this.props.onClickGraphic('year', [{ year: Number(uno.activeLabel) }])
      }
    } catch (e) { }
  }

  onChangeGraph = () => {
    if (this.state.type === 'line') {
      this.setState({ type: 'bar' });
    } else {
      this.setState({ type: 'line' });
    }
  }

  onChangeColor = (color) => {
    if (color === 'Verde') {
      this.setState({ colors: colors })
    } else if (color === 'Rojo') {
      this.setState({ colors: colors1 })
    } else if (color === 'Verde-Azul') {
      this.setState({ colors: colors2 })
    } else if (color === 'Gris') {
      this.setState({ colors: colors3 })
    } else if (color === 'Azul') {
      this.setState({ colors: colors4 })
    } else if (color === 'Policromático') {
      this.setState({ colors: colors5 })
    }
  }

  getDate = () => {
    try {
      return (
        <Grid container>
          <Grid item xs={12} className="text-center client-label-second-color font-12">
            Actualizado a: {this.props.date.split('T')[0]}
          </Grid>
        </Grid>
      )
    } catch (e) { }
  }

  domain = () => {
    if (this.props.data[0].value.length === 0)
      return [0, 0];
    let resp = this.props.data[0].value.reduce((acum, data) => {
      if (acum.value < data.value)
        return data;
      return acum;
    })
    return [0, (parseInt(resp.value * 1.2) + 1)];
  }

  render() {
    return (
      <Grid style={{ flexWrap: "inherit", margin: 'auto' }} id={this.props.name} xs={12} item>
        <ChartMenu graph={this.props.name} file={this.props.title} onCloseMenu={this.handleClose} title={this.props.title} watch={this.props.watchMenu}
          seeMore={this.props.seeMore}
          onChangeGraph={this.onChangeGraph}
          changeGraph={true}
          changeColor={true}
          onChangeColor={this.onChangeColor}
          openDialog={this.props.openDialog}
        />
        <Grid container>
          <Grid item xs={12}

          >
            {
              (this.state.type === 'line') ?
                <LineChart width={this.getWidth()} height={250} data={this.getData()}
                  margin={{ top: 5, right: 15, bottom: 5, left: 0 }} style={{ margin: 'auto' }}
                  onClick={this.onClick}
                  className='on-mouse-hover'
                >
                  <XAxis dataKey="name" fontSize={12} interval={0} className='on-mouse-hover' />
                  <YAxis fontSize={12} allowDecimals={false} domain={this.domain()} className='on-mouse-hover' />
                  <Tooltip className='on-mouse-hover' />
                  <Legend />
                  {
                    this.getLine()
                  }
                </LineChart>
                :
                <BarChart width={this.getWidth()} height={250} data={this.getData()}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  onClick={this.onClick}
                  className='on-mouse-hover'>
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis dataKey="name" interval={0} fontSize={12} />
                  <YAxis fontSize={12} allowDecimals={false} domain={this.domain()} />
                  <Tooltip />
                  <Legend />
                  {
                    this.props.data.map((val, index) => {
                      return <Bar type="monotone" dataKey={val.name}
                        fill={this.state.colors[index % this.state.colors.length]}
                        key={'bar-line-' + this.props.name + index}
                        label={{ position: 'top', fontSize: 14 }}
                      />
                    })
                  }
                </BarChart>
            }
          </Grid>
        </Grid>
        {
          this.getDate()
        }
      </Grid>
    )
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(null, mapDispathToProps)(LineComponent);
